export default {
  tokenKey: 'CiaoToy-Admin-Token',
  // 管理后台信息
  website: {
    name: 'CiaoToy后台管理系统',
    version: '1.0.0',
    desc: '珠宝交易管理平台',
    // logo仅支持在线地址
    // logo: 'http://zhouyi.run:5222/api/public/admin/getFiles?id=5d38c26acf509bdcab4f8c677ce90088.png&&mimetype=image/png',
  },
  // 页脚备案信息
  reference: {
    show: true, //是否展示页脚
    number: '',//备案号
    authorization: '', // 站点所属机构
  },
  appArticleUrl: '/support/',
}